export function shouldRunInitialIdentityLoad(options: {
  client?: { initialRequest?: boolean }
}) {
  return Boolean(options.client?.initialRequest) && !process.env.VITEST
}
